<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div [ngClass]="{
    'hidden': isHidden(),
    'show': !isHidden()}"
    class="input-search-loading-container">

  <div class="loading-container selected">
    <div class="value">
      <div *ngIf="!isErrorState"><div class="loading-icon-small"></div> Loading data. please wait..</div>
      <div *ngIf="isErrorState"><i class="fa fa-exclamation-triangle" style="color: orange; margin-right: 5px;" aria-hidden="true"></i> <span style="color: red;"> Network connection problem. </span></div>
    </div>
  </div>
</div>

<div [ngClass]="{'hidden': !isHidden()}" class="input-search-container" #rootElement>
  <div class="input-container"
    [ngClass]="{'disabled': disabled, 'selected': inputValue, 'multiple': multiple,
    'bordered': invalid,
    'bordered-source': warningSource,
    'has-warning': required && (inputText.errors && (inputText.dirty || inputText.touched))}" [ngStyle]="{'width': isWidth ? '180px' : ''}">

    <ng-container *ngIf="multiple">
      <div *ngFor="let arr of arrValue; let i=index" class="mvalue hinted">
        <div class="name">{{getValue(arr)}}</div>
        <div class="hint" *ngIf="getEmailValue(arr)">{{getEmailValue(arr)}}</div>
        <div class="remove"><i class="fa fa-times" aria-hidden="true"
            (click)="removeSelected(i)"></i></div>
      </div>
    </ng-container>

    <input #inputText type="text" class="input-search crm-field" autocomplete="off"
      [ngClass]="{'hidden': inputValue, 'regular': regular && !searchable, 'right-bordered': invalid, 'right-bordered-source': warningSource}"
      [name]="name" [(ngModel)]="searchQuery"
      [disabled]="disabled" [placeholder]="multiple && arrValue?.length > 0 ? '' : placeholder" [required]="required"
      [readonly]="regular && !searchable" (focus)="onShow()"
      (keydown.arrowdown)="onKeyArrowDown($event)" (keydown.arrowup)="onKeyArrowUp($event)"
      (keydown.enter)="onKeyEnter($event)" (keyup.space)="onKeySpace($event)"
      maxlength="50"/>

    <div class="value" *ngIf="inputValue && !multiple">
      {{inputValue ? getValue(inputValue) : placeholder}}
      <span *ngIf="showEmail">{{getEmail(inputValue) ? '(' + getEmail(inputValue) + ')' : '' }}</span>
    </div>

    <!-- Copy to Clipboard -->
    <div class="relative">
      <div @fadeOut class="copied" *ngIf="copiedClicked">Text Copied!</div>
      <button type="button" *ngIf="inputValue && showCopy" (click)="copyText()"
        class="copybtn btn btn-rbv ml-2 d-flex align-items-center">
        <i class="fa fa-clone"></i>
      </button>
    </div>

    <!--Arrow Down Button-->
    <ng-container *ngIf="!isNoDropIcon && !multiple">
      <a *ngIf="(noCancel || !inputValue)" (click)="onShow()" [ngClass]="{'disabled': disabled}" class="dropdown-button">
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </a>
    </ng-container>

    <!-- Close Button -->
    <ng-container *ngIf="noCancel == false">
      <a class="lock-icon" *ngIf="inputValue && !disabled && !isNoDropIcon" (click)="onClear()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </a>
    </ng-container>

    <span class="help-block" *ngIf='required && (inputText.errors && (inputText.dirty || inputText.touched))'>
      required
    </span>
  </div>

  <div *ngIf="isOpen && !isNoDropIcon" class="dropdown-items" [ngClass]="{'bottom': !topFlag ,'top': topFlag}">
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-icon-small"></div>
    </div>

    <div #container (scroll)="onScrollHandler($event)" *ngIf="!isLoading" id="DROPDOWN_ITEMS" class="item-container">
      <ng-container *ngIf="preset?.length > 0 && searchQuery.length <= 0">
        <div class="header" *ngIf="presetHeader">{{presetHeader}}</div>
        <div class="item preset" [id]="'PRESET_ITEMS_' + pi" [ngClass]="{'active': p.active, 'offset': presetHeader, 'highlight': highligtValue === p.ID}"
          (click)="onSelected(p)" *ngFor="let p of preset; let pi=index">
          {{displayFull ? p.getFullDetails() : p.getName()}}
        </div>
      </ng-container>

      <ng-container *ngIf="items.length > 0">
        <div class="header" *ngIf="itemsHeader">{{itemsHeader}}</div>

        <div class="item" [id]="'ITEMS_' + ci" [ngClass]="{'active': c.active, 'offset': presetHeader, 'not-allowed': position && !c.allowed}"
          (click)="onSelected(c)" *ngFor="let c of items; let ci=index">
           <i *ngIf="!parent || (userIcon && !c?.CLIENT)" class="fa fa-user-circle-o" style="color: #1e3762; margin-right: 5px" aria-hidden="true"></i>
           <i *ngIf="position && !c.allowed" class="fa fa-exclamation-triangle" style="color: orange; margin-right: 5px;" aria-hidden="true"></i>
           <i *ngIf="userIcon && c?.CLIENT?.IS_LSP" class="fa fa-building-o " style="color: #1e3762; margin-right: 5px" aria-hidden="true"></i>
           {{displayFull ? !linkReportType ? c.getFullDetails() : c.getValue().getReportType() : c.getName()}}
        </div>
      </ng-container>

      <ng-container *ngIf="(!(items.length > 0) && searchQuery?.length > 0 && !userInputAllowed && !typeEmail && !isErrorState)">
        <div class="item no-records-found">
          No Records Found
        </div>
      </ng-container>

      <ng-container *ngIf="isErrorState">
        <div class="item no-records-found">
          <i class="fa fa-exclamation-triangle" style="color: orange; margin-right: 5px;" aria-hidden="true"></i>
          <span style="color: red;"> Network connection problem. </span>
        </div>
      </ng-container>

      <div *ngIf="loadMoreLoading" class="item loading-more">
        <div class="loading-icon-small"></div>
      </div>

    </div>

    <div *ngIf="showCreate" class="bottom-btn">
      <button (click)="createNewAction()" class="btn btn-link"> <i class="fa fa-plus"></i> Create new </button>
    </div>

    <div *ngIf="showManage" class="bottom-btn">
      <button (click)="onManage()" class="btn btn-link"> Manage </button>
    </div>
  </div>
</div>
